import LeftLeafSVG from '../../../../icons/LeftLeafSVG'
import RightLeafSVG from '../../../../icons/RightLeafSVG'
import RiveComponent from '../../../../components/RiveComponent'

const HERO_EMBLEM_SIZE = 78

export function ElitePlansHeroEmblem({
  riveSrc,
  fallbackSrc,
  alt
}: {
  riveSrc: string
  fallbackSrc: string
  alt: string
}) {
  return (
    // Callers render this inside a px-5 column; negative margins make it full-bleed.
    // The .riv artboard has a baked-in solid background; the blend mode lets the hero gradient
    // show through it, and only works while no ancestor up to .ep-page-bg sets a z-index.
    <div
      role='img'
      aria-label={alt}
      className='-mx-5 -mt-[100px] aspect-[375/300] w-[calc(100%+2.5rem)] overflow-hidden [mix-blend-mode:var(--ep-emblem-blend)]'
    >
      <RiveComponent
        src={riveSrc}
        stateMachines='State Machine 1'
        playOnView
        fallback={
          <img
            src={fallbackSrc}
            alt=''
            width={HERO_EMBLEM_SIZE}
            height={HERO_EMBLEM_SIZE}
            className='mx-auto h-[78px] w-[78px] object-contain'
          />
        }
      />
    </div>
  )
}

export function ElitePlansHeroBadge({
  children,
  className = 'text-[color:var(--ep-hero-strong)]'
}: {
  children: string
  className?: string
}) {
  return (
    <p className={`ep-theme-tween text-sm font-medium tracking-wide ${className}`}>
    </p>
  )
}

export function ElitePlansHeroHeadline({
  headlineSans,
  headlineSerif
}: {
  headlineSans: string
  headlineSerif: string
}) {
  return (
    <h1 className='ep-theme-tween max-w-[20ch] text-[clamp(28px,10vw,32px)] font-medium leading-[1.2] text-[color:var(--ep-headline-sans)]'>
      {headlineSans}{' '}
      <span className='font-libre-caslon mx-auto block w-fit bg-[image:var(--ep-headline-serif-bg)] bg-clip-text pt-1 font-semibold text-transparent'>
        {headlineSerif}
      </span>
    </h1>
  )
}

export function ElitePlansHeroSubcopy({ children }: { children: string }) {
  return (
    <p className='mt-3 max-w-[327px] bg-gradient-to-r from-[color:var(--ep-subcopy-from)] to-[color:var(--ep-subcopy-to)] bg-clip-text text-13 font-normal leading-[1.5] text-transparent'>
      {children}
    </p>
  )
}
